import React, { useEffect } from 'react';
// import { FinishProfileSetupCard } from './finish-profile-setup-card';
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardGreeting from './DashboardGreeting';
import RecentlyViewedHandouts from '../handout/recently-viewed-handouts';
import { useSnackbar } from '../SnackbarProvider';
import DashboardStartPanels from './DashboardStartPanels';
import HandoutsOfTheMonth from '../handout/handouts-of-the-month';
import DashboardPromoPanel from './DashboardPromoPanel';

export function HomeScreen() {
    const navigate = useNavigate();
    const location = useLocation();
    const showSnackbar = useSnackbar();

    useEffect(() => {
        if (location?.state?.subscriptionSuccess) {
            showSnackbar(
                'Your subscription details have been successfully updated. Start enjoying the benefits now!',
                'success',
            );
            // clear  state to prevent the message from showing again on subsequent navigations
            navigate(location.pathname, { replace: true, state: {} });
        }
        const trialSuccess = localStorage.getItem('trialSuccess');
        if (trialSuccess) {
            showSnackbar(
                'Your 14 day free professional trial is confirmed. Start enjoying the benefits now!',
                'success',
            );
            localStorage.removeItem('trialSuccess');
        }
    }, [location, showSnackbar, navigate]);

    return (
        <>
            <DashboardGreeting />

            {/* <FinishProfileSetupCard /> */}

            <RecentlyViewedHandouts />

            <DashboardStartPanels />

            <HandoutsOfTheMonth />

            <DashboardPromoPanel />
            {/* CETRA-735:
             * "Tell us how we're doing" panel removed from Home footer.
             * "Suggest a handout" panel is intentionally hidden for now and will be moved to Handout Library later.
             */}
        </>
    );
}
